import React from "react";

const Sagitario = ({...r}) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 120 120" {...r}>
      <path
        fill="#0250C9"
        d="M88.427 28.003H66.133a3.583 3.583 0 00-2.616.99 3.56 3.56 0 00-1.097 2.567 3.55 3.55 0 001.097 2.567 3.574 3.574 0 002.616.99h13.909L56.656 58.421l-9.853-9.82a3.574 3.574 0 00-5.046 0 3.55 3.55 0 000 5.029l9.853 9.82-22.565 22.48A3.554 3.554 0 0028 88.444a3.545 3.545 0 001.045 2.514A3.568 3.568 0 0031.568 92a3.578 3.578 0 002.523-1.041l22.565-22.487 8.624 8.6a3.574 3.574 0 005.046 0 3.549 3.549 0 000-5.029l-8.63-8.594L84.86 40.367v14.3c.037.92.429 1.79 1.094 2.427a3.579 3.579 0 004.952 0A3.555 3.555 0 0092 54.668V31.579a3.55 3.55 0 00-1.04-2.528 3.573 3.573 0 00-2.533-1.048z"
      ></path>
    </svg>
  );
}

export default Sagitario;